import { FC } from 'react';
import cs from 'classnames';
import { leftListSelectionDOM } from 'src/views/lcn/pages/sitemap/ts-config';
import styles from '../index.module.less';
import { useMethods } from '@lhb/hook';
import IconFont from '@/common/components/IconFont';
import { Badge } from 'antd';

const SecondMenu:FC<{
  firstMenuItem,
  setActive,
  active,
  curLeftSection
}> = ({
  firstMenuItem,
  setActive,
  active,
  curLeftSection,
}) => {
  const secondeActiveItems = curLeftSection?.find(item => item.code === firstMenuItem.code)?.children;

  const methods = useMethods({
    onSecondeMenuMouseEnter(item) {
      setActive(item.code);
    },
  });

  return <>
    {
      !!secondeActiveItems?.length && <div
        className={cs(leftListSelectionDOM, styles.secondMenu)}
      >
        {secondeActiveItems.map((item, index) => <div
          key={index}
          className={cs(styles.secondMenuItem, item.code === active ? styles.activeCard : '')}
          onMouseEnter={() => methods.onSecondeMenuMouseEnter(item)}
        >
          <Badge
            count={item.count}
            size='small'
            overflowCount={10}
          >
            <span className={styles.label}>{item.label}</span>
          </Badge>
          <IconFont iconHref='iconic_next_black_seven' className={styles.icon}/>
        </div>)}

      </div> }

  </>;
};

export default SecondMenu;
